import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private permissionList: { page: string, path: string }[] = [];
  private allPermissions: string[] = [];

  constructor() {
    this.loadPermissions()
  }

  setPermissions(permissions: { page: string, path: string }[], rawPermissions: string[] = []): void{
    this.permissionList = permissions;
    this.allPermissions = rawPermissions;
    localStorage.setItem('permissionList', JSON.stringify(this.permissionList));
    localStorage.setItem('allPermissions', JSON.stringify(this.allPermissions));
  }

  getPermissions(): { page: string, path: string }[]{
    return this.permissionList
  }

  hasPermission(permissionName: string): boolean {
    return this.allPermissions.includes(permissionName);
  }

  private loadPermissions(): void {
    const permissions = localStorage.getItem('permissionList');
    if (permissions) {
      this.permissionList = JSON.parse(permissions);
    }
    const allPermissions = localStorage.getItem('allPermissions');
    if (allPermissions) {
      this.allPermissions = JSON.parse(allPermissions);
    }
  }
}
